import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import IntegrationSettingDto from '@/models/IntegrationSettings/IntegrationSettingDto';

export default class UpdateIntegrationSettingsRequest extends BaseUpdateRequest {
	settings: IntegrationSettingDto[] = [];  
    
}